const MENSAJE_GENERICO =
    "Se produjo un error inesperado en el servidor. Inténtelo de nuevo y, si persiste, avise al administrador.";

const MENSAJE_SIN_RESPUESTA =
    "No se pudo contactar con el servidor. Compruebe su conexión e inténtelo de nuevo.";

const MENSAJE_SERVIDOR_NO_DISPONIBLE =
    "El servidor no está disponible en este momento. Inténtelo de nuevo en unos minutos.";

const MENSAJES_POR_ESTADO = {
    400: "Los datos enviados no son válidos. Revíselos e inténtelo de nuevo.",
    401: "Su sesión ha caducado. Vuelva a iniciar sesión.",
    403: "No tiene permiso para realizar esta acción.",
    404: "No se encontró lo que busca. Puede que se haya eliminado.",
    502: MENSAJE_SERVIDOR_NO_DISPONIBLE,
    503: MENSAJE_SERVIDOR_NO_DISPONIBLE,
    504: MENSAJE_SERVIDOR_NO_DISPONIBLE
};

const PATRONES_VOLCADO = [
    /^[\w.]+(Exception|Error)[:\s]/, // "System.InvalidOperationException: ..."
    /\n\s+(at|en) \S+\(/,            // líneas de pila
    /\nHEADERS\n=+/                  // página de error de desarrollo de ASP.NET
];

/**
 * Un volcado de excepción no es un mensaje: no cabe en un toast ni le dice nada al usuario
 */
const esVolcadoDeExcepcion = texto => PATRONES_VOLCADO.some(patron => patron.test(texto));

const esPaginaHtml = texto => /^\s*</.test(texto);

/**
 * Texto del cuerpo de la respuesta (string o data.message) tal cual llega, sin filtrar; null si no trae ninguno
 */
export const textoDeLaRespuesta = error => {
    const data = error && error.response && error.response.data;
    const texto = typeof data === "string" ? data : data && data.message;
    return typeof texto === "string" ? texto : null;
};

const noHuboRespuesta = error => Boolean(error && error.request && !error.response);

/**
 * Mensaje que el backend quiso mostrar al usuario, o uno propio cuando no hay ninguno que mostrar
 */
export const getErrorMessage = error => {
    if (noHuboRespuesta(error)) return MENSAJE_SIN_RESPUESTA;
    if (!error.response) return error.message || error.toString();

    const mensaje = textoDeLaRespuesta(error);
    if (!mensaje || !mensaje.trim() || esPaginaHtml(mensaje)) return MENSAJES_POR_ESTADO[error.response.status] || MENSAJE_GENERICO;
    return esVolcadoDeExcepcion(mensaje) ? MENSAJE_GENERICO : mensaje;
};
